import { getNews } from "../../api/article";
import { getColumns } from "../../api/dictionary"
import _ from 'lodash';
export default {
    state: {
        total: 0,
        news: [],
        currentTabs: [],
        navs: [],
        showChildTabs: false,
        childrenTabs: [],
        newsId: "",
        columnId: "",
        tabs: [],
        loading: false,
    },
    mutations: {
        SET_CURRENTTYPE: (state, data) => {
            state.currentTabs = [];
            _.forEach(state.tabs, p => {
                if (p.columnPath == data.path) {
                    state.currentTabs.push({ label: p.label })
                    if (p.children != null) {
                        state.currentTabs = _.concat(state.currentTabs, p.children)
                    }
                }
            })
        },
        CHANGE_NEWS: (state, data) => {
            state.news = [];
            state.news = [...data.rows]
            state.total = data.total
        },
        SET_TABS: (state, data) => {
            state.tabs = []
            state.tabs = [...data]
        },
        SET_NAVS: (state, data) => {
            state.navs = []
            state.navs.push({ url: "/", text: "首页" });
            for (let p of data.rows) {
                state.navs.push({ url: p.columnPath, text: p.label });
            }
        },
        SET_CHILDTABS: (state, data) => {
            _.forEach(state.tabs, p => {
                let childTabs = _.filter(p.children, k => k.id == data.id)
                if (childTabs.length != 0 && childTabs[0].children != null) {
                    state.showChildTabs = true
                    state.childrenTabs = childTabs[0].children
                    return false;
                }
                else {
                    state.showChildTabs = false
                    state.childrenTabs = []
                }
            })
        },
        SET_SHOWCHILDTABS: (state) => {
            state.showChildTabs = false;
        },
        SET_HOMENEWS: (state, data) => {
            state.newsId = data.newsId
            state.columnId = data.columnId
        },
        resetState: (state) => {
            state.news = [];
        },
        showLoading: (state) => {
            state.loading = true 
        },
        hideLoading: (state) => {
            state.loading = false 
        },
    },
    actions: {
        async getNews({ commit }, val) {
            commit("showLoading");
            commit("resetState");
            let result = await getNews(val);
            commit("CHANGE_NEWS", result.data);
            commit("hideLoading");
        },
        async getColumns({ commit }, val) {
            let result = await getColumns();
            commit("SET_NAVS", result.data);
            commit("SET_TABS", result.data.rows)
        },
    },
    getters: {
        total: state => state.total,
        news: state => state.news,
        currentTabs: state => state.currentTabs,
        navs: state => state.navs,
        showChildTabs: state => state.showChildTabs,
        childrenTabs: state => state.childrenTabs,
        newsId: state => state.newsId,
        columnId: state => state.columnId,
        loading: state => state.loading,
        tabs: state => state.tabs,
    }
}